export default __webpack_public_path__ + "static/media/politie.52b29b62.mp3";